{
  "checkedInTitle": "Anda telah didaftar masuk",
  "postCheckInInstructions": "Arahan selepas daftar masuk",
  "appointmentDetails": "Butiran temu janji",
  "notifyWarehouse": "Kami memaklumkan gudang bahawa anda telah tiba supaya mereka dapat menyemak ketersediaan mereka",
  "waitForStaff": "Sila tunggu arahan lanjut daripada kakitangan gudang",
  "unplannedDescription": "Nampaknya anda tiada temujanji. Sila tunggu arahan lanjut daripada kakitangan gudang.",
  "whatsappDelay": "Mesej WhatsApp pertama mungkin mengambil masa sehingga satu minit untuk sampai.",
  "bookNextTitle": "Tempah temu janji untuk lain kali",
  "bookNextBody": "Daftar dengan Opendock supaya anda boleh menempah temu janji pada lawatan seterusnya ke kemudahan ini",
  "helpFooter": "Jika anda memerlukan bantuan atau maklumat tambahan, sila hubungi kakitangan gudang",
  "finalize": "Selesaikan ({seconds})"
}
